import { Button, Stack, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import ConditionalWrapper from "components/conditional-wrapper";
import { useBookingStateContext } from "hooks/use-booking-state";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { getSearchParams } from "search-params";
import { hasBookingPassed, isWaitListOfferLocked } from "utils/booking";

const BookMoreButton = ({ sticky }: { sticky: boolean }) => {
    const { t } = useTranslation();
    const location = useLocation() as TypedHistory;
    const isFinal = location.state?.isFinal;
    const { isActivityBooking } = useBookingStateContext();

    const { data: webBooking } = useWebBooking();

    if (!webBooking) return null;

    const hasPassed = hasBookingPassed(webBooking);
    const isOfferLocked = isWaitListOfferLocked(webBooking);

    const { system, isExperienceViewMode } = getSearchParams();
    const offerLocked = isOfferLocked && !hasPassed && !isFinal;
    const alignment = offerLocked ? "center" : "flex-start";

    let bookMoreUrl = `${window.location.origin}/${system}/${webBooking.unitId}`;
    if (isActivityBooking) bookMoreUrl += "/activity-booking";
    if (isExperienceViewMode) bookMoreUrl += "/experience-view";
    bookMoreUrl += window.location.search;

    return (
        <>
            <ConditionalWrapper
                condition={sticky}
                wrapper={(children) => (
                    <>
                        <Stack
                            position="fixed"
                            bottom="0"
                            left="0"
                            right="0"
                            zIndex="docked"
                            alignItems="center"
                            width="100%"
                            p={ThemeSpaceVariable.Medium}
                        >
                            {children}
                        </Stack>
                        {/* Spacer for sticky button */}
                        <Stack
                            position="absolute"
                            bottom={`calc(${ThemeSpaceVariable.X2Large} * -1)`}
                            w="1px"
                            h="1px"
                        />
                    </>
                )}
            >
                <Button
                    variant="primary"
                    size="xl"
                    alignSelf={alignment}
                    href={bookMoreUrl}
                    w={sticky ? "100%" : "auto"}
                    data-track-click="mybooking-book-more"
                >
                    {offerLocked ? t("toBookingStart") : t("bookMore")}
                </Button>
            </ConditionalWrapper>
        </>
    );
};

export default BookMoreButton;
